import React, { useEffect, useMemo, useState } from "react";
import "./doctors.css";
import sphere2 from "../../assets/images/Ellipse 2.png";
import sphere3 from "../../assets/images/Ellipse 3.png";
import Doctor from "../doctor/Doctor";
import { API_URL } from "../../config";
import { useTranslation } from "../../shared/LanguageContext";

export default function Doctors() {
  const [doctors, setDoctors] = useState([]);
  const { t } = useTranslation();

  // Грузим список из API
  useEffect(() => {
        const loadDoctors = async () => {
            try {
                const res = await fetch(`${API_URL}/doctors`);
                const data = await res.json();
                if (Array.isArray(data)) {
                    setDoctors(data);
                } else {
                    console.error("Ожидался массив данных, получено:", data);
                }
            } catch (err) {
                console.error("Ошибка загрузки врачей:", err);
            }
        };
        loadDoctors();
  }, []);

  return (
    <div className="doctors-container">
      <h3 id="docs">{t("docs_title")}</h3>
      <p>{t("docs_subtitle")}</p>

      <img className="sphere2" src={sphere2} alt="sphere2" />
      <img className="sphere3" src={sphere3} alt="sphere3" />

      <div className="doctors-wrapper">
        <Doctor doctorsList={doctors} />
      </div>
    </div>
  );
}
